import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { Calculator, Save, CheckCircle2 } from 'lucide-react';

const AccountingDefaultsCard = () => {
  const [users, setUsers] = useState([]);
  const [current, setCurrent] = useState('');
  const [selected, setSelected] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  const load = async () => {
    try {
      const [u, d] = await Promise.all([api.get('/auth/users/directory'), api.get('/settings/accounting-defaults')]);
      const list = Array.isArray(u.data) ? u.data : (u.data?.data || []);
      setUsers(list.filter((x) => ['admin', 'account', 'accountant'].includes(x.role)));
      setCurrent(d.data.default_accountant_id || '');
      setSelected(d.data.default_accountant_id || '');
    } catch (err) {
      console.error('Failed to load accounting defaults', err);
    }
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    setMsg(null);
    setBusy(true);
    try {
      const r = await api.put('/settings/accounting-defaults', { default_accountant_id: selected });
      const name = r.data.default_accountant?.name || r.data.default_accountant?.username;
      setMsg({ type: 'success', text: name ? `New invoice follow-up tasks will be assigned to ${name}.` : 'New invoice follow-up tasks will be left unassigned.' });
      setCurrent(r.data.default_accountant_id || '');
    } catch (e) {
      setMsg({ type: 'error', text: e?.response?.data?.detail || 'Could not save.' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card p-6 mb-4" data-testid="accounting-defaults-card">
      <h2 className="font-head text-xl font-bold mb-1 flex items-center gap-2" style={{ color: 'var(--cc-dark-green)' }}><Calculator size={16}/> Invoice Follow-up Tasks</h2>
      <p className="text-sm mb-4" style={{ color: 'var(--cc-text-muted)' }}>
        Every new Proforma or Tax invoice automatically creates a payment follow-up task in Accounting Tasks. Pick who it should be assigned to. The task closes itself once the invoice is fully paid.
      </p>
      <div className="flex flex-col sm:flex-row sm:items-end gap-3">
        <div className="flex-1">
          <label className="label text-xs">Default accountant</label>
          <select className="input" value={selected} onChange={(e) => setSelected(e.target.value)} data-testid="accounting-defaults-select">
            <option value="">— Leave unassigned —</option>
            {users.map((u) => (
              <option key={u.id} value={u.id}>{u.name || u.username}{u.role ? ` (${u.role})` : ''}</option>
            ))}
          </select>
        </div>
        <button type="button" onClick={save} disabled={busy || selected === current} className="btn btn-primary" data-testid="accounting-defaults-save">
          <Save size={14}/> {busy ? 'Saving…' : 'Save'}
        </button>
      </div>
      {msg && (
        <div className="text-xs rounded-md p-2.5 mt-3 inline-flex items-center gap-1.5"
          style={msg.type === 'error' ? { background: '#FEF2F2', color: '#991B1B', border: '1px solid #FCA5A5' } : { background: '#D1FAE5', color: '#065F46', border: '1px solid #34D399' }}
          data-testid="accounting-defaults-msg">
          {msg.type === 'success' && <CheckCircle2 size={12}/>}
          {msg.text}
        </div>
      )}
    </div>
  );
};

export default AccountingDefaultsCard;
